import { Link } from 'react-router-dom';
import PageSEO from '@/components/base/PageSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '国产一区精选内容聚合平台',
  url: 'https://guochan1qu.com',
  description:
    '国产一区精选内容聚合平台，致力于为用户提供最全面、最优质的国产原创内容聚合服务。汇聚影视综娱、科技数码、生活百科、文学艺术、音乐天地、游戏动漫等八大分类精选内容。',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'contact@guochan1qu.com',
    availableLanguage: ['Chinese'],
  },
};

const stats = [
  { value: '10,000+', label: '精选内容', icon: 'ri-article-line' },
  { value: '8', label: '内容分类', icon: 'ri-folder-line' },
  { value: '50万+', label: '月活跃用户', icon: 'ri-user-heart-line' },
  { value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line' },
];

const milestones = [
  {
    year: '2023',
    title: '平台诞生',
    description:
      '国产一区精选内容聚合平台正式上线，以"汇聚国产精品，传播原创力量"为使命，开始为用户提供优质的国产原创内容聚合服务。',
  },
  {
    year: '2024',
    title: '快速成长',
    description:
      '平台内容库突破一万篇，分类体系逐步完善，月活跃用户突破三十万，成为国产原创内容领域的重要聚合平台。',
  },
  {
    year: '2025',
    title: '品质升级',
    description:
      '全面升级内容审核机制，引入编辑精选制度，确保每一篇内容都经过严格筛选。用户满意度达到行业领先水平。',
  },
  {
    year: '2026',
    title: '生态拓展',
    description:
      '与超过200位优质原创作者建立合作关系，内容覆盖范围进一步扩大，致力于打造最全面的国产原创内容生态系统。',
  },
];

export default function AboutPage() {
  return (
    <>
      <PageSEO
        title="关于我们 - 国产一区精选内容聚合平台"
        description="国产一区精选内容聚合平台品牌介绍。了解我们的使命愿景、发展历程、平台信誉与联系方式。汇聚海量优质国产原创内容，一站式浏览体验。"
        keywords="国产一区,关于国产一区,国产原创内容平台,内容聚合平台介绍"
        canonicalUrl="https://guochan1qu.com/about"
        schemaData={[orgSchema]}
      />

      <ScrollToTop />
      <Navbar />

      <main className="min-h-screen pt-20 pb-14 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>

          {/* Brand Introduction */}
          <section className="mb-16">
            <div className="text-center mb-10">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-500 rounded-2xl">
                <i className="ri-vip-crown-line text-2xl text-background-50"></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                关于国产一区
              </h1>
              <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                国产一区精选内容聚合平台，致力于汇聚最全面、最优质的国产原创内容。我们相信，在信息的海洋中，精心筛选和分类整理的内容才能真正为用户创造价值。从影视综娱到科技数码，从生活百科到文学艺术，我们用心打造每一个内容分类，只为给您最好的浏览体验。
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-xl p-5 text-center border border-background-200"
                >
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-lg text-primary-600">
                    <i className={`${stat.icon} text-lg`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Mission & Vision */}
          <section className="mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="bg-accent-50 border border-accent-200 rounded-xl p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg text-accent-600 mb-3">
                  <i className="ri-focus-3-line text-lg"></i>
                </div>
                <h2 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                  我们的使命
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  汇聚国产精品内容，传播原创力量。我们致力于打造一个开放、共享的内容聚合平台，让每一位用户都能便捷地获取优质的国产原创内容，让每一位创作者的优秀作品都能被更多人所看见。
                </p>
              </div>

              <div className="bg-primary-50 border border-primary-200 rounded-xl p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg text-primary-600 mb-3">
                  <i className="ri-eye-line text-lg"></i>
                </div>
                <h2 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                  我们的愿景
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  成为最受用户信赖的国产原创内容聚合平台。我们希望通过持续的技术创新和内容优化，不断提升用户的浏览体验，让国产一区成为每个人获取优质国产内容的首选平台。
                </p>
              </div>
            </div>
          </section>

          {/* Development Timeline */}
          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200 md:-translate-x-px"></div>
              <div className="flex flex-col gap-8">
                {milestones.map((item, index) => (
                  <div
                    key={item.year}
                    className={`relative flex flex-col md:flex-row gap-4 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className="absolute left-4 md:left-1/2 w-3 h-3 bg-primary-500 rounded-full -translate-x-1/2 mt-1.5 z-10 ring-4 ring-background-50"></div>
                    <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                      <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-2">
                        {item.year}
                      </span>
                      <h3 className="text-base font-heading font-bold text-foreground-950 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                    <div className="md:w-1/2 hidden md:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
              平台信誉
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="bg-background-100 rounded-xl p-6 border border-background-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-xl text-accent-600">
                  <i className="ri-shield-check-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-950 mb-2">
                  内容审核严格
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  所有内容均经过编辑团队严格审核，确保原创性、真实性和可读性，杜绝低质和虚假信息。
                </p>
              </div>

              <div className="bg-background-100 rounded-xl p-6 border border-background-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-xl text-accent-600">
                  <i className="ri-user-star-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-950 mb-2">
                  用户口碑优良
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  累计服务超过50万用户，用户满意度持续保持在行业领先水平，口碑传播是平台最重要的增长来源。
                </p>
              </div>

              <div className="bg-background-100 rounded-xl p-6 border border-background-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-xl text-accent-600">
                  <i className="ri-lock-line text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-950 mb-2">
                  数据安全可靠
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  采用先进的加密技术和安全防护体系，严格保护用户隐私，服务可用率达99.9%。
                </p>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
              联系我们
            </h2>
            <div className="bg-background-100 rounded-xl p-8 border border-background-200">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-xl text-primary-600">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-heading font-bold text-foreground-950 mb-1">
                    电子邮箱
                  </h3>
                  <p className="text-xs text-foreground-500">
                    contact@guochan1qu.com
                  </p>
                </div>

                <div>
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-xl text-primary-600">
                    <i className="ri-customer-service-2-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-heading font-bold text-foreground-950 mb-1">
                    客服热线
                  </h3>
                  <p className="text-xs text-foreground-500">
                    400-888-XXXX
                  </p>
                </div>

                <div>
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-xl text-primary-600">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-heading font-bold text-foreground-950 mb-1">
                    服务时间
                  </h3>
                  <p className="text-xs text-foreground-500">
                    周一至周五 9:00-18:00
                  </p>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-background-200">
                <p className="text-sm text-foreground-500 text-center">
                  如果您有任何问题、建议或合作意向，欢迎随时通过以上方式与我们联系。
                  我们会在24小时内回复您的消息。期待与您的交流！
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}